import type {Locale} from '../../i18n.config';
import type {GuideFM, Content} from '../library/types';
import Image from 'next/image';
import Link from 'next/link';
import {localizePath} from '../library/languages';

type Props = {
  locale: Locale;
  guide: Content<GuideFM>;
  blurDataURL: string;
  priority?: boolean;
};

export default function Guide({
  locale,
  guide,
  blurDataURL,
  priority = false,
}: Props) {
  const path = `/guides/${guide.scope.slug}`;

  return (
    <li className="my-8 flex flex-col overflow-hidden rounded-md bg-gray-50 dark:bg-gray-900 shadow-md sm:flex-row">
      <Link
        href={localizePath(path, locale)}
        className="relative aspect-video sm:w-64">
        <Image
          src={guide.frontmatter.image}
          alt={guide.frontmatter.title}
          sizes="(max-width: 640px) 100vw, 256px"
          quality={90}
          priority={priority}
          placeholder="blur"
          blurDataURL={blurDataURL}
          className="object-cover"
          fill
        />
      </Link>
      <div className="flex-1 text-ellipsis p-4">
        <span className="text-lg font-extrabold text-primary">
          {guide.frontmatter.game.name}
        </span>
        <Link href={localizePath(path, locale)}>
          <h2 className="text-2xl font-extrabold text-gray-700 dark:text-white">
            {guide.frontmatter.title}
          </h2>
        </Link>
        <p className="mt-1">{guide.frontmatter.description}</p>
      </div>
    </li>
  );
}
